import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_qa34rdc6hh: FaireCollectionEntity = {
  token: "pbc_qa34rdc6hh",
  type: "collection",
  name: "SS26 Bonbon Soleil Organic Wovens",
  heroImageUrl:
    "https://cdn.faire.com/fastly/13e63e9cfa9ee986fca810be547367b8d057362e4f1f070138bc5aa226652384.jpeg",
  itemCount: 40,
  description:
    "Celebrate the season with unique, handcrafted designs featuring delicate hand embroidery, smocking, and enchanting prints on luxurious fabrics like linen and organic muslin. Unparalleled Comfort: Ultra-soft, lightweight, breathable, and cozy—perfect for all seasons.\n",
  brandToken: "b_7fghelgl",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-11T04:59:17.747Z",
    importedBy: "entity-db-import-collections",
  },
};
